// PREAUREUM cart drawer helpers. Moved from snippets/cart-drawer.liquid for browser caching.
(function () {
    if (window.__hcCartDiscountInitialized) return;
    window.__hcCartDiscountInitialized = true;

    var NOTICE_KEY = 'hcCartDiscountNotice';

    function getRootUrl() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    }

    function getCartUpdateUrl() {
      return getRootUrl() + 'cart/update.js';
    }

    function getDiscountScope(target) {
      return target.closest('[data-hc-cart-discount]') || document;
    }

    function getElements(target) {
      var scope = getDiscountScope(target);

      return {
        scope: scope,
        input: scope.querySelector('[data-hc-cart-discount-input]'),
        button: scope.querySelector('[data-hc-cart-discount-apply]'),
        status: scope.querySelector('[data-hc-cart-discount-status]')
      };
    }

    function toggleDiscountPanel(toggle) {
      var scope = getDiscountScope(toggle);
      var panel = scope.querySelector('[data-hc-cart-discount-panel]');
      if (!panel) return;

      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      panel.hidden = !willOpen;

      if (willOpen) {
        var input = panel.querySelector('[data-hc-cart-discount-input]');
        if (input) input.focus({ preventScroll: true });
      }
    }

    function getAppliedDiscountCodes(target) {
      var scope = getDiscountScope(target);

      return Array.prototype.slice
        .call(scope.querySelectorAll('[data-hc-cart-discount-code]'))
        .map(function (chip) {
          return (chip.dataset.hcCartDiscountCode || '').trim();
        })
        .filter(Boolean);
    }

    function getCartDrawerStrings() {
      if (window.HcCartDrawerStrings) return window.HcCartDrawerStrings;

      var config = document.querySelector('[data-hc-cart-drawer-strings]');
      if (!config) return {};

      try {
        window.HcCartDrawerStrings = JSON.parse(config.textContent || '{}');
      } catch (error) {
        window.HcCartDrawerStrings = {};
      }

      return window.HcCartDrawerStrings;
    }

    function getButtonLabel(button, state) {
      var strings = getCartDrawerStrings();
      var attribute = state === 'applying'
        ? 'hcCartDiscountApplyingLabel'
        : 'hcCartDiscountApplyLabel';
      var fallback = state === 'applying'
        ? strings.discountApplying || ''
        : strings.discountApply || '';

      return button && button.dataset && button.dataset[attribute]
        ? button.dataset[attribute]
        : fallback;
    }

    function setStatus(status, message, state) {
      if (!status) return;

      status.hidden = false;
      status.textContent = message;
      status.dataset.state = state || 'info';
    }

    function clearStatus(status) {
      if (!status) return;

      status.hidden = true;
      status.textContent = '';
      status.removeAttribute('data-state');
    }

    function setBusy(button, isBusy) {
      if (!button) return;

      button.disabled = isBusy;
      button.setAttribute('aria-busy', isBusy ? 'true' : 'false');

      var buttonText = button.querySelector('[data-hc-cart-discount-button-text]');
      if (buttonText) {
        buttonText.textContent = getButtonLabel(button, isBusy ? 'applying' : 'apply');
      }
    }

    function getRequestedSections() {
      var mainCartItems = document.getElementById('main-cart-items');
      var mainCartFooter = document.getElementById('main-cart-footer');

      // On /cart, ask Shopify to return the cart section so the page totals,
      // applied-code chips and button state can be refreshed in place.
      if (mainCartItems && mainCartFooter && mainCartItems.dataset.id) {
        return [mainCartItems.dataset.id, 'cart-icon-bubble', 'cart-live-region-text'];
      }

      var cartDrawerItems = document.querySelector('cart-drawer-items');

      if (cartDrawerItems && typeof cartDrawerItems.getSectionsToRender === 'function') {
        return cartDrawerItems
          .getSectionsToRender()
          .map(function (section) {
            return section.section || section.id;
          })
          .filter(Boolean)
          .slice(0, 5);
      }

      return ['cart-drawer', 'cart-icon-bubble'];
    }

    function getVisibleDiscountCodes(cart) {
      var codes = [];

      function addCode(application, requireDiscountCodeType) {
        if (!application) return;
        if (requireDiscountCodeType && application.type !== 'discount_code') return;

        var code = (application.code || application.title || '').trim();
        if (!code) return;

        if (!codes.some(function (existingCode) {
          return existingCode.toLowerCase() === code.toLowerCase();
        })) {
          codes.push(code);
        }
      }

      if (!cart) return codes;

      (cart.discount_applications || []).forEach(function (application) {
        addCode(application, true);
      });

      (cart.cart_level_discount_applications || []).forEach(function (application) {
        addCode(application, true);
      });

      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          addCode(allocation.discount_application, true);
        });

        (item.discounts || []).forEach(function (discount) {
          addCode(discount, false);
        });
      });

      return codes;
    }

    function getDiscountOutcome(updatedCart, requestedCode) {
      var normalizedRequestedCode = (requestedCode || '').trim().toLowerCase();
      var requestedCodeIsVisible = getVisibleDiscountCodes(updatedCart).some(function (code) {
        return code.toLowerCase() === normalizedRequestedCode;
      });

      if (requestedCodeIsVisible) {
        return {
          state: 'success',
          message: getCartDrawerStrings().discountApplied || ''
        };
      }

      return {
        state: 'warning',
        message: getCartDrawerStrings().discountNotApplied || ''
      };
    }

    function storeNotice(message, state) {
      try {
        window.sessionStorage.setItem(
          NOTICE_KEY,
          JSON.stringify({
            message: message,
            state: state || 'info'
          })
        );
      } catch (error) {}
    }

    function consumeNotice() {
      var rawNotice;

      try {
        rawNotice = window.sessionStorage.getItem(NOTICE_KEY);
        window.sessionStorage.removeItem(NOTICE_KEY);
      } catch (error) {
        rawNotice = null;
      }

      if (!rawNotice) return;

      try {
        var notice = JSON.parse(rawNotice);
        var status = document.querySelector('#main-cart-footer [data-hc-cart-discount-status]') ||
          document.querySelector('[data-hc-cart-discount-status]');

        if (notice && notice.message && status) {
          setStatus(status, notice.message, notice.state);
        }
      } catch (error) {}
    }

    async function updateCartDiscount(code) {
      var requestedSections = getRequestedSections();
      var payload = {
        discount: code
      };

      if (requestedSections.length > 0) {
        payload.sections = requestedSections.join(',');
        payload.sections_url = window.location.pathname + window.location.search;
      }

      var response = await fetch(getCartUpdateUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      var data = await response.json().catch(function () {
        return null;
      });

      if (!response.ok) {
        var message =
          (data && (data.description || data.message || data.status)) ||
          getCartDrawerStrings().discountApplyError ||
          getCartDrawerStrings().discountApplyFallbackError ||
          '';

        throw new Error(message);
      }

      return data;
    }

    function renderCartIconBubble(cartState) {
      if (!cartState || !cartState.sections || !cartState.sections['cart-icon-bubble']) return;

      var currentBubble = document.getElementById('cart-icon-bubble');
      if (!currentBubble) return;

      var parsedBubble = new DOMParser().parseFromString(
        cartState.sections['cart-icon-bubble'],
        'text/html'
      );

      var newBubble = parsedBubble.getElementById('cart-icon-bubble');

      if (newBubble) {
        currentBubble.replaceWith(newBubble);
      }
    }

    function renderCartSections(cartState) {
      if (!cartState || !cartState.sections) return false;

      var mainCartItems = document.getElementById('main-cart-items');
      var mainCartFooter = document.getElementById('main-cart-footer');
      if (mainCartItems && mainCartFooter && mainCartItems.dataset.id) {
        var mainCartHtml = cartState.sections[mainCartItems.dataset.id];
        if (mainCartHtml) {
          var parsedMainCart = new DOMParser().parseFromString(mainCartHtml, 'text/html');
          var newItemsContent = parsedMainCart.querySelector('#main-cart-items .js-contents');
          var newFooterContent = parsedMainCart.querySelector('#main-cart-footer .js-contents');
          var currentItemsContent = mainCartItems.querySelector('.js-contents');
          var currentFooterContent = mainCartFooter.querySelector('.js-contents');

          if (newItemsContent && newFooterContent && currentItemsContent && currentFooterContent) {
            currentItemsContent.innerHTML = newItemsContent.innerHTML;
            currentFooterContent.innerHTML = newFooterContent.innerHTML;
            var cartItemsElement = mainCartItems.closest('cart-items');
            if (cartItemsElement) cartItemsElement.classList.toggle('is-empty', cartState.item_count === 0);
            renderCartIconBubble(cartState);
            return true;
          }
        }
      }

      var cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        try {
          cartDrawer.renderContents(cartState);
          cartDrawer.classList.toggle('is-empty', cartState.item_count === 0);
          return true;
        } catch (error) {}
      }

      var cartDrawerItems = document.querySelector('cart-drawer-items');

      if (cartDrawerItems && typeof cartDrawerItems.renderContents === 'function') {
        try {
          cartDrawerItems.renderContents(cartState);

          var fallbackCartDrawer = document.querySelector('cart-drawer');
          if (fallbackCartDrawer) {
            fallbackCartDrawer.classList.toggle('is-empty', cartState.item_count === 0);
          }

          return true;
        } catch (error) {}
      }

      var drawerHtml = cartState.sections['cart-drawer'];
      var drawerInner = document.querySelector('#CartDrawer .drawer__inner');

      if (drawerHtml && drawerInner) {
        var parsedDrawer = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var newDrawerInner =
          parsedDrawer.querySelector('#CartDrawer .drawer__inner') ||
          parsedDrawer.querySelector('.drawer__inner');

        if (newDrawerInner) {
          drawerInner.replaceWith(newDrawerInner);

          var cartDrawerElement = document.querySelector('cart-drawer');
          if (cartDrawerElement) {
            cartDrawerElement.classList.toggle('is-empty', cartState.item_count === 0);
          }

          renderCartIconBubble(cartState);
          return true;
        }
      }

      renderCartIconBubble(cartState);
      return false;
    }

    function restoreDiscountFocus() {
      window.setTimeout(function () {
        consumeNotice();

        var toggle = document.querySelector('#main-cart-footer [data-hc-cart-discount-toggle]') ||
          document.querySelector('[data-hc-cart-discount-toggle]');
        if (toggle) toggle.focus({ preventScroll: true });
      }, 0);
    }

    async function applyDiscount(target) {
      var elements = getElements(target);
      var input = elements.input;
      var button = elements.button;
      var status = elements.status;

      if (!input || !button) return;

      var code = input.value.trim();

      if (!code) {
        input.setAttribute('aria-invalid', 'true');
        input.classList.add('is-error');
        setStatus(status, getCartDrawerStrings().discountEmpty || '', 'error');
        input.focus();
        return;
      }

      input.removeAttribute('aria-invalid');
      input.classList.remove('is-error');
      clearStatus(status);
      setBusy(button, true);

      if (window.HcCartDrawerLoading) {
        window.HcCartDrawerLoading.begin(getCartDrawerStrings().discountApplyingCode || '');
      }

      try {
        var appliedCodes = getAppliedDiscountCodes(target);
        var hasCode = appliedCodes.some(function (appliedCode) {
          return appliedCode.toLowerCase() === code.toLowerCase();
        });

        if (!hasCode) appliedCodes.push(code);

        var updatedCart = await updateCartDiscount(appliedCodes.join(','));
        var outcome = getDiscountOutcome(updatedCart, code);

        storeNotice(outcome.message, outcome.state);

        var didRender = renderCartSections(updatedCart);

        if (didRender) {
          restoreDiscountFocus();
        } else {
          window.location.reload();
        }
      } catch (error) {
        input.setAttribute('aria-invalid', 'true');
        input.classList.add('is-error');

        setStatus(
          status,
          error && error.message ? error.message : getCartDrawerStrings().discountApplyFallbackError || '',
          'error'
        );

        setBusy(button, false);
      } finally {
        if (window.HcCartDrawerLoading) {
          window.HcCartDrawerLoading.clear();
        }
      }
    }

    async function removeDiscount(target) {
      var elements = getElements(target);
      var status = elements.status;
      var removedCode = (target.dataset.hcCartDiscountRemove || '').trim();

      if (!removedCode) return;

      var remainingCodes = getAppliedDiscountCodes(target).filter(function (code) {
        return code.toLowerCase() !== removedCode.toLowerCase();
      });

      target.disabled = true;
      target.setAttribute('aria-busy', 'true');
      clearStatus(status);

      if (window.HcCartDrawerLoading) {
        window.HcCartDrawerLoading.begin(getCartDrawerStrings().discountRemoving || '');
      }

      try {
        var updatedCart = await updateCartDiscount(remainingCodes.join(','));
        var message = getCartDrawerStrings().discountRemoved || '';
        storeNotice(message, 'success');

        var didRender = renderCartSections(updatedCart);

        if (didRender) {
          restoreDiscountFocus();
        } else {
          window.location.reload();
        }
      } catch (error) {
        target.disabled = false;
        target.setAttribute('aria-busy', 'false');
        setStatus(
          status,
          error && error.message ? error.message : getCartDrawerStrings().discountRemoveError || '',
          'error'
        );
      } finally {
        if (window.HcCartDrawerLoading) {
          window.HcCartDrawerLoading.clear();
        }
      }
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-hc-cart-discount-toggle]');

      if (toggle) {
        event.preventDefault();
        toggleDiscountPanel(toggle);
        return;
      }

      var removeButton = event.target.closest('[data-hc-cart-discount-remove]');

      if (removeButton) {
        event.preventDefault();
        removeDiscount(removeButton);
        return;
      }

      var button = event.target.closest('[data-hc-cart-discount-apply]');

      if (!button) return;

      event.preventDefault();
      applyDiscount(button);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      if (!event.target.matches('[data-hc-cart-discount-input]')) return;

      event.preventDefault();
      applyDiscount(event.target);
    });

    document.addEventListener('DOMContentLoaded', consumeNotice);
  })();
